import { FaHtml5, FaCss3, FaServer, FaNode } from "react-icons/fa";
import {
  SiTailwindcss,
  SiJavascript,
  SiMongodb,
} from "react-icons/si";
export const projectsData = [
  {
    id: 1,
    projectName: "PayTm-Mall Clone",
    projectDesc: " Paytm Mall is subsidary of Paytm and a B2C model.",
    tags: [
      ["Tech Stacks :"],
      // ["HTML | TAILWIND CSS | EJS Express | MongoDB"],
      [
        <FaHtml5 color="#3949AB" style={{ marginLeft: 18, marginTop: 5, }} size={25} />,
        <SiTailwindcss color="#3949AB" style={{ marginLeft: 18, marginTop: 5, }} size={25} />,
        <SiJavascript color="#3949AB" style={{ marginLeft: 18, marginTop: 5, }} size={25} />,
        <FaNode color="#3949AB" style={{ marginLeft: 18, marginTop: 5, }} size={25} />,
        <SiMongodb color="#3949AB" style={{ marginLeft: 18, marginTop: 5, }} size={25} />,
      ],
    ],
    code: "https://github.com/sinab06/PayTM-Mall-Clone.git",
    demo: "https://paytm-mall-clone.netlify.app/",
    image:
      // "http://bsmedia.business-standard.com/_media/bs/img/article/2017-07/10/full/1499671228-5463.jpg",
      "https://cdn.zeebiz.com/sites/default/files/styles/zeebiz_850x478/public/2019/05/13/86525-paytm.jpg?itok=cD3i5Bvg&c=4d942a74b30a9cd43bb1639dd6002b86",
  },
  {
    id: 2,
    projectName: "Overstock Clone",
    projectDesc: "Overstock.com, Inc. is an American internet retailer selling primarily furniture",
    tags: [
      ["Tech Stacks :"],
      // ["HTML | TAILWIND CSS | JAVASCRIPT | Mock Server"],
      [
        <FaHtml5 color="#3949AB" style={{ marginLeft: 20, marginTop: 5, }} size={25} />,
        <SiTailwindcss color="#3949AB" style={{ marginLeft: 20, marginTop: 5, }} size={25} />,
        <SiJavascript color="#3949AB" style={{ marginLeft: 20, marginTop: 5, }} size={25} />,
        <FaServer color="#3949AB" style={{ marginLeft: 20, marginTop: 5, }} size={25} />,
      ],
    ],
    code: "https://github.com/sinab06/Clone-Overstock.com.git",
    demo: "https://overstock-clone.netlify.app/",
    image: 
    // "https://www.carriermanagement.com/assets/overstock.png",
    "https://www.slashgear.com/img/gallery/overstock-bitcoin-payments-begin/intro-import.webp",
  },
  {
    id: 3,
    projectName: "Bewakoof Clone",
    projectDesc:
      "Bewakoof is an Indian e-commerce for fashionable clothing & accessories.",
    tags: [
      ["Tech Stacks :"],
      // ["HTML | CSS | JAVASCRIPT"],
      [
        <FaHtml5 color="#3949AB" style={{ marginLeft: 30, marginTop: 5, }} size={25} />,
        <FaCss3 color="#3949AB" style={{ marginLeft: 30, marginTop: 5, }} size={25} />,
        <SiJavascript color="#3949AB" style={{ marginLeft: 30, marginTop: 5, }} size={25} />,
      ],
    ],
    code: "https://github.com/aramanrajput/bewkoof.github.io.git",
    demo: "https://bewkoof-aramanrajput.vercel.app/",
    image:
      // "https://cdn.dribbble.com/users/23005/screenshots/4913209/media/78c944018a48769f9329509815ba6e13.png?compress=1&resize=800x600&vertical=top",
      "https://indian-retailer.s3.ap-south-1.amazonaws.com/s3fs-public/2021-03/1_3.JPG",
  },
  // {
  //     id: 3,
  //     projectName: 'Weather App',
  //     projectDesc: 'Weather forecast systems and applications predict weather conditions based on multiple parameters.',
  //     tags: ['Django', 'CSS', 'Material Ui'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: three
  // },
  // {
  //     id: 4,
  //     projectName: 'Android Patient Tracker',
  //     projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
  //     tags: ['Flutter', 'Firebase'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: four
  // },
  // {
  //     id: 5,
  //     projectName: 'E-Commerce App',
  //     projectDesc: 'A Simple E-commerce application',
  //     tags: ['React Native', 'Firebase'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: five
  // },
  // {
  //     id: 6,
  //     projectName: 'Uber Lite',
  //     projectDesc: 'Uber clone',
  //     tags: ['Flutter'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: six
  // },
  // {
  //     id: 7,
  //     projectName: 'Stock Market App',
  //     projectDesc: 'A simple stock market API app',
  //     tags: ['React', 'Redux', 'Bootstrap'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: seven
  // },
  // {
  //     id: 8,
  //     projectName: 'Car Pooling System',
  //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
  //     tags: ['Flutter', 'React'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: eight
  // },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
